/* eslint-disable eqeqeq */
import dayjs from "dayjs";

let _prev_uid_ = "";

export const generate = (code) => {
  return code && `PT${code}${dayjs().format("yyyyMMDDHHmmss")}`;
};

export const UID = (_pre = "UID") => {
  const uid = `${_pre}_${dayjs().format("yyyyMMDDHHmmss")}`;

  const [_uid, count] = _prev_uid_.split("-");

  if (uid == _uid) return (_prev_uid_ = `${uid}-${parseInt(count) + 1}`);

  return (_prev_uid_ = `${uid}-0`);
};
